const Marionette = require('lib/marionette')
const _ = require('lib/underscore')
const UserController = require('page/signup/user_controller')
const SocialAuth = require('module/social_auth/social_auth')
const Dialog = require('module/dialog/dialog')
const radio = require('lib/radio')
const log = require('log').create('home', 'onboarding')

const channel = radio.signup
const metrics = radio.metrics_signup


const OnboardingController = Marionette.MnObject.extend({

    initialize(options) {
        _.bindAll(this, 'oauthFBSuccess', 'oauthGoogleSuccess', 'oauthError')
        // initiate user if it doesn't exist
        if (! channel.request('user')) {
            this.user_controller = new UserController()
        }
        this.user = channel.request('user')
        // ensures user's info doesn't show for next user
        channel.request('reset')

        this.initializeListeners()

        this.listenTo(radio.auth, 'google:auth:success', this.oauthGoogleSuccess)
        this.listenTo(radio.auth, 'google:auth:fail', this.oauthError)

        this.auth_controller = new SocialAuth({
            google_button: options.google_button,
        })

    },

    initializeListeners() {
        radio.auth.on('click:signup:google', () => {
            this.onClickSignupGoogle()
        })
        radio.auth.on('click:signup:email', () => {
            this.onClickSignupEmail()
        })
        radio.auth.on('click:signup:facebook', () => {
            this.onClickSignupFacebook()
        })
    },

    onClickSignupEmail() {
        log('onClickSignupEmail')
        this.user.set('signup.method', 'email')
        channel.request('save')

        // analytics
        metrics.trigger('method:chosen', {
            method: 'email',
        })

        this.showSignupPage('/signup')
    },

    onClickSignupFacebook() {
        this.user.set('signup.method', 'facebook')
        this.user.set('signup.oauth_status', 'started')
        radio.signup.request('save')

        // analytics
        metrics.trigger('method:chosen', {
            method: 'facebook',
        })

        const promise = radio.auth.request('facebook:authorize')
        promise.done(this.oauthFBSuccess)
        promise.fail(this.oauthError)
    },
    oauthFBSuccess(data) {
        const output = data.output
        const authResponse = data.response.authResponse
        // If they logged in, send them to home.
        if (output.login && output.redirect) {
            window.location = output.redirect
        } else {

            // Create the users onboarding doc, including their email if they provided it.
            if (output.data.email) {
                this.user.set('signup.email_from_social', true)
            }

            this.user.save({
                'email_address': output.data.email,
                'facebook_uid': output.data.id,
                'facebook_access_token': authResponse.accessToken,
            }).done(() => {
                this.user.set('signup.oauth_status', 'complete')
                radio.signup.request('save')
                this.showSignupPage('/signup/name')
            }).fail(() => {
                radio.signup.request('reset')
                Dialog.banner({
                    html: 'We were unable to process your signup through Facebook. Please try another method.',
                    status: 'warning',
                })
            })
        }
    },

    onClickSignupGoogle() {
        log('onClickSignupGoogle')
        this.user.set('signup.method', 'google')
        this.user.set('signup.oauth_status', 'started')
        radio.signup.request('save')

        // analytics
        metrics.trigger('method:chosen', {
            method: 'google',
        })

        // the actual request is handled by google's click handler
        // which is attached to the DOM element(s) we provide them
    },
    oauthGoogleSuccess(data) {
        const output = data.output
        // Whether its login or signup, oauth comes full circle to a close.
        this.user.set('signup.oauth_status', 'complete')

        // If the user has already signed up with google, just sign them in.
        if (output.login && output.redirect) {
            window.location = output.redirect

        } else if (output.data) {
            log('google data', output.data)

            if (output.data.email) {
                this.user.set('signup.email_from_social', true)
            }

            // If they are a new user, set the email address and move on to the next step.
            this.user.save({
                'email_address': output.data.email,
                'first_name': output.data.given_name,
                'last_name': output.data.family_name,
                'google_access_token': output.data.google_id,
            }).done(() => {
                this.user.set('signup.oauth_status', 'complete')
                radio.signup.request('save')
                this.showSignupPage('/signup/name')
            }).fail(() => {
                radio.signup.request('reset')
                Dialog.banner({
                    html: 'There was a problem signing in with Google. Please try another method.',
                    status: 'warning',
                })
            })

        } else {
            radio.signup.request('reset')
            Dialog.banner({
                html: 'There was a problem signing in with Google. Please try another method.',
                status: 'warning',
            })
        }
    },

    oauthError(data) {
        if (data && data.message) {
            Dialog.banner({
                html: data.message,
                status: 'warning',
            })
        }
    },

    showSignupPage(path) {
        window.location = path
    },

})

module.exports = OnboardingController
